// @flow

const EVENTS = {
	DMS_REDIRECT_TO: 'dms-redirect-to',
	REQUEST_CLINICS_APP_PAYLOAD: 'request-dms-clinics-app-payload',
	RESPONSE_CLINICS_APP_PAYLOAD: 'response-dms-clinics-app-payload',
	SHOW_MEDICAL_CALL_CENTER_PHONES: 'dms-show-medical-call-center-phones',
	REQUEST_LOG_EVENT_BANNER_CLICK: 'request-log-event-banner-click',
	REQUEST_TELEMED_APP_PAYLOAD: 'request-dms-telemed-app-payload',
	RESPONSE_TELEMED_APP_PAYLOAD: 'response-dms-telemed-app-payload',
	REQUEST_TELEMED_HUB_APP_PAYLOAD: 'request-dms-telemed-hub-app-payload',
	RESPONSE_TELEMED_HUB_APP_PAYLOAD: 'response-dms-telemed-hub-app-payload',
};

export {
	EVENTS,
};
